module.exports = __webpack_public_path__ + "media/images/character/zen_chan_right-12182bb15dc8898b748fc6b2075b5173.png";